import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PersonalInformationComponent } from './personal-information.component';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { SuccessMessageComponent } from 'src/app/components/success-message/success-message.component';
import { ClickOutsideModule } from 'src/app/directives/click-outside/click-outside.module';
import { DateDefaultFormatPipe } from 'src/app/pipes/date-format.pipe';



@NgModule({
  declarations: [
    PersonalInformationComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode'
    }),
    ClickOutsideModule,
    ComponentsModule,
    DateDefaultFormatPipe,
  ],
  providers: [
    SuccessMessageComponent
  ]
})
export class PersonalInformationModule { }
